import { connect, mapProps, mapReadPretty, h } from '@formily/vue';
import { defineComponent } from '@vue/composition-api';
import { transformComponent } from '@formily/vant/esm/__builtins__/shared';
import { PreviewText } from '@formily/vant';
import { Radio as VanRadio, RadioGroup as VanRadioGroup } from 'vant';

const TransformVanRadioGroup = transformComponent(VanRadioGroup, {
  change: 'input',
});

const RadioGroupOption = defineComponent({
  name: 'FRadioGroup',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  setup(customProps, { attrs, slots, listeners }) {
    return () => {
      const options = customProps.options || [];
      const children = options.length !== 0
        ? {
            default: () => options.map((option) => {
              if (typeof option === 'string') {
                return h(VanRadio, { props: { label: option, name: option } }, {
                  default: () => [option],
                });
              }
              return h(VanRadio, { props: { ...option } }, {
                default: () => [option.label],
              });
            }),
          }
        : slots;
      return h(TransformVanRadioGroup, { attrs, on: listeners }, children);
    };
  },
});

const RadioGroup = connect(
  RadioGroupOption,
  mapProps({ dataSource: 'options' }),
  mapReadPretty(PreviewText.Checkbox)
);

const Radio = VanRadio;
Radio.Group = RadioGroup;

export default Radio;
